import { asset } from "./assets";

export const PAST_EVENTS = [
  {
    // The 6 Nov 2022 Lifestyle Fair. On the old site this card linked only to
    // its registration form (https://tinyurl.com/MGMS-Lifestyle-Nov22), which
    // is now closed; the November fair was never photographed (only the
    // August one, MGMS 1.0, has an album). So it falls back to the gallery
    // hub rather than a dead form or the wrong album's photos.
    title: "LifeStyle Fair - MGMS 2.0",
    date: "6 Nov 2022",
    href: "/gallery",
    label: "Gallery",
  },
  {
    // The 14 Aug 2022 Lifestyle Fair - its own album (the old site linked the
    // card to the gallery hub; we point straight at the matching album).
    title: "LifeStyle Fair - MGMS 1.0",
    date: "14 Aug 2022",
    href: "/gallery/lifestyle-fair-2022",
    label: "Photos",
  },
  {
    // The original Meet-Greet-Meditate-Share (the "MGMS Life Style" card on
    // the old /events), photographed in its own album. Restored here: the
    // rebuild had dropped it, orphaning the album from the events archive.
    title: "Meet-Greet-Meditate-Share",
    date: "12 Jun 2022",
    href: "/gallery/meet-greet-meditate-share-2022",
    label: "Photos",
  },
  {
    title: "Meditation Challenge",
    date: "1 May 2022 - 30 May 2022",
    href: "/events/meditation-challenge",
    label: "Details",
  },
  {
    title: "International Gita Forum (IGF)",
    date: "Sant Naamdeo - 20 Mar 2021",
    href: "/events/igf-2021",
    label: "Details",
  },
] as const;

export const CHALLENGE = {
  editions: [
    {
      title: "2025 (April) Global Meditation Challenge",
      dates: "7th to 27th April 2025 (21 days)",
      workshops: 25,
      href: "https://globalmeditationchallenge.com",
      external: true,
      banner: asset(
        "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1280/8aec0ab1552e4445a007a40fddaef485.jpg?v=250703010154",
      ),
    },
    {
      title: "2022 (May) Global Meditation Challenge",
      dates: "1st to 30th May 2022 (30-days)",
      workshops: 27,
      href: "#2022",
      external: false,
      banner: asset(
        "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1280/0c84de18353a42cbabf54361ae6dcb58.jpg?v=250703010154",
      ),
    },
  ],
  what: {
    title: "What is Meditation Challenge?",
    body: "You challenge yourself to get engaged in this programme to be benefited from regular practice of Meditation.",
    points: [
      "Starts on 1st May 2022",
      "Ends on 30th May 2022",
      "Pre-registration required, starts from 1st April 2022",
      "Meditate anytime & then submit the report, daily for 30-days",
      "Worldwide participants",
    ],
  },
  forMe: {
    title: "What Is In It For Me?",
    points: [
      "Learn a unique meditation",
      "Change in habit in your daily life to make it stress-free",
      "Control the uncontrolled Mind",
      "Continue daily meditation practice after finishing the challenge",
      "E-certificates, Prizes",
      "Talks, Discussion, Yoga session, Ayurveda, Naturopathy, Fitness, Sanskrit, Gita, Painting, etc.",
      "Daily Tips on Meditation",
      "Inner peace",
    ],
  },
  /**
   * Verbatim from the 2022 challenge page's 14-question FAQ. Questions 5 and
   * 6 ("Will you teach me how to Meditate?" / "How will I access the online
   * meditation practice classes?") carried region-by-region 2022 Zoom
   * IDs and meeting passwords for a challenge that closed in 2022; that
   * schedule is stale and the passwords are still live credentials for
   * dormant meetings, so those two answers are left null (question-only)
   * rather than republished into a permanent archive. Every other answer
   * is reproduced verbatim, typos included ("koin", "plentyful", "only e
   * possible", "Mediation Challenge").
   */
  faq: [
    {
      question: "When does the registration start?",
      answer:
        "Registration starts on 1st April 2022 and will close on 30th April 2022. You can register through https://tinyurl.com/MeditationChallenge1",
    },
    {
      question: "Is there any fee for this challenge?",
      answer:
        "Your contribution is optional.\n\nIf you are willing to contribute, you may choose the option. If you don't want to, opt for the free option. The contribution options are US$15 / US$20 / US$30. You may pay by Debit Card / Credit Card / PayPal / PayNow through secured payment plugin in the registration form.",
    },
    {
      question: "When does the challenge start? Can I begin whenever I want?",
      answer:
        "The Challenge starts on 1st May 2022, and will finish on 30th May 2022.",
    },
    {
      question: "Can I start and stop during the challenge?",
      answer:
        "The Challenge would be considered completed when you start on 1st May and finish on 30th May by meditating DAILY and submitting the report DAILY. If you start & stop in between, its OK but you will not be able to complete the 30-days challenge.",
    },
    {
      question: "Will you teach me how to Meditate?",
      answer: null,
    },
    {
      question: "How will I access the online meditation practice classes?",
      answer: null,
    },
    {
      question: "How do I submit my report of a day?",
      answer:
        "You will receive the Google Form link to submit the daily report in your email immediately you register for the challenge.\n\nEveryday, we will remind in the WhatsApp / Telegram groups to submit the report. Hence, please join the group as per instructions in the registration email sent.",
    },
    {
      question: "How many online meditation classes can I join?",
      answer:
        "As many as you can every day. However, to complete the challenge, you need minimum 1 time meditation practice. You may practice on your own as well. BUT you must report daily!",
    },
    {
      question: "What if I miss a day to Meditate? Is there any SCORE?",
      answer:
        "With every miss you will lose your SCORE, and you will not be able to complete 30-days challenge!\n\nOnce meditated, submit the report using a Daily Report Submission Google Form (please check your registration email for the Google Form Link).\n\n1. If you practice Meditation at least once a day & submit the report for all 30 days, you will complete the Challenge!\n2. Score Card will be prepared based on your daily report submission\n3. 1 point per day for your 1st Meditation | Earn additional 0.5 point for your 2nd meditation (in other Time Bracket than your 1st meditation) on your Same Day. No additional point for 3 or more meditation in a day.\n4. The Time Brackets (as per your local time) are 3am-6am; 6am-10am; 10am-4pm; 4pm-7pm; 7pm-10pm, 10pm-3am\n5. Earn additional 3 points for every 10-days consecutive meditation without any gaps. That means, if you complete 30-days, you will earn 9 points (3 points for each 10-days) for making it consecutive. Similarly, if you meditate 2 times 10-days consecutive, your earned points will be 6.\n\nYou may Meditate on your own. Or you may koin our plentyful online practice sessions in various countries. You may join any of these as per your convenience to meditate daily. But don't forget to submit the REPORT.",
    },
    {
      question:
        "I tend to jump into things, and then not finish them. How can I be sure I'll make it through the four weeks?",
      answer:
        "The best part about doing this challenge is the accountability and inspiration we give you to keep you on-track. When you set your goals for the challenge, we'll hold you accountable to sticking with it through regular reminder and motivation. We'll give you virtual check-ins via email and send you daily inspiration in the WhatsApp / Telegram group.",
    },
    {
      question:
        "What happens if I sign up, and then realize it's not right for me? Do you give refunds?",
      answer:
        "We don't want to keep your fees unnecessarily. But automatic refund would not be possible. You will have to write to us at vysingapore@gmail.com, and we will refund your fees. Please note that this would only e possible if you write to us by 10th May 2022. We will communicate with you for refund process once you approach us.",
    },
    {
      question: "What will I achieve after completing the challenge?",
      answer:
        "The Mediation Challenge has following objectives (but not limited to):\n\n- Learn Meditation\n- Create a habit of meditation practice\n- Achieve to stay calm in adverse conditions\n- Continue to practice with us on a regular basis after finishing the challenge\n- Correct your basis to experience the self-upliftment\n- E-certificates to all participants with a Score\n- Opportunity to attend multiple Talks & Discussion on Meditation, Yoga, Ayurveda, etc.",
    },
    {
      question: "How will I receive the certificate?",
      answer:
        "The challenge would complete on 30th May 2022. You will receive your certificate with your Score via email by 1st June 2022.",
    },
    {
      question: "I have other questions!",
      answer:
        "Great! Just email us at vysingapore@gmail.com and we'll answer you right away.",
    },
  ] satisfies { question: string; answer: string | null }[],
  results: {
    title: "30-Days Global Meditation Challenge (1st-30th May 2022): Result",
    posters: [
      {
        src: asset(
          "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/596-844-595-836-0-4/117fe18fbca541c89c710d8ab2ec33fc.jpg?v=250703010154",
        ),
        alt: "Congratulation, 105 winners",
      },
      {
        src: asset(
          "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/593-839-593-836-0-1/b3bc4dddc9f248a8b3200fd079f712e5.jpg?v=250703010154",
        ),
        alt: "Prizes",
      },
      {
        src: asset(
          "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/598-545-594-545-1-0/69433b2a641445ec80c3a158bea45ec4.jpg?v=250703010154",
        ),
        alt: "Congratulation, 35 highest scorers",
      },
    ],
    notes: [
      "The above mentioned prizes are for all 105 WINNERS of the Challenge. You are entitled to select any one of these from 5 items.",
      "In Individuals will be contacted by the organisers separately for your PRIZES soon. Thank you for your patience.",
      "The HIGHEST Scores are entitled for an additional Secret PRIZE !",
    ],
  },
  youtube: "https://www.youtube.com/embed/w72AhXEgCzU",
} as const;

export const IGF = {
  title: "International Gita Forum",
  date: "20 Mar 2021",
  lead: "Click here to watch the event International Gita Forum happened on 20 Mar 2021",
  video: "https://youtu.be/mBk47k2-oMM",
  posters: [
    {
      src: asset(
        "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/480-678-480-678-0-0/F1AC14E3BB015198.png?v=250703010154",
      ),
      alt: "International Gita Forum 2021 with Naamdeo ji, Know the Supreme Being",
    },
    {
      src: asset(
        "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/480-678-480-678-0-0/CDDA8C85472B6810.png?v=250703010154",
      ),
      alt: "International Gita Forum 2021, about Naamdeo ji",
    },
  ],
} as const;
